import { PasswordResetForm } from '@shared/features/auth/components/PasswordResetForm';

export default function ForgotPasswordPage() {
  return (
    <div className="container mx-auto px-4 py-16">
      <div className="flex justify-center">
        <PasswordResetForm />
      </div>
    </div>
  );
}